import { render } from "./IconCancel.vue?vue&type=template&id=ce790096"
import script from "./IconCancel.vue?vue&type=script&lang=js"
export * from "./IconCancel.vue?vue&type=script&lang=js"
script.render = render

export default script